import { useState, React, useEffect } from 'react'
import { FaGithub, FaGlobe, FaTag, FaTags, FaCalendarAlt, FaCode, FaStopwatch, FaStopwatch20 } from 'react-icons/fa';
import { Link as LinkRouter } from 'react-router-dom';
import { makeBlogPostURL } from './makeURL';
import { useMediaQuery } from '@material-ui/core';
import * as blogTagColors from '../content/blogTagColors.json';
import { calcReadingTime } from './utils';





const BlogPostSection = ({ contentDict, className }) => {

  const isMobile = useMediaQuery('(max-width: 768px)');
  const title = contentDict["title"] || "404: No Title Found";
  let finishDate = contentDict["finishDate"];
  if (finishDate) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    finishDate = finishDate.toLocaleDateString('en-US', options);
  }
  const description = contentDict["description"] || "404: No Description Found";
  const tags = contentDict["tags"] || [];
  const coverImage = contentDict["coverImage"] || null;
  const hidden = contentDict["hidden"] || false;
  const authors = contentDict["authors"] || [];
  const [readingTime, setReadingTime] = useState(0);

  useEffect(() => {
    async function fetchReadingTime() {
      const readingTime = await calcReadingTime(contentDict.markdownFile);
      setReadingTime(readingTime);
    }
    fetchReadingTime();
  }, [])

  // Took out the symbols...
  // <FaCalendarAlt className='mr-1 md:mr-2'/>
  // <FaTags className='md:mr-2 mt-0.5' />

  const dateAndTags = (
     <div className={`flex md:flex-col md:mt-2 md:mr-8 text-xs md:space-y-1 text-dark-accent dark:text-light-accent2 ${className}`}>
      <div className='flex items-center'>
        { isMobile ? null : <FaCalendarAlt className='mr-1'/> }
        <span>{finishDate}</span>
        { isMobile ? <>&nbsp;&nbsp;&middot;&nbsp;&nbsp;</> : null }
      </div>
      <div className='flex items-center'>
        { isMobile ? null : <FaStopwatch className='mr-1'/> }
        <span>{ readingTime } min</span>
        { isMobile ? <>&nbsp;&nbsp;&middot;&nbsp;&nbsp;</> : null }
      </div>
      <div className='flex items-center md:items-start'>
        { isMobile ? null : <FaTags className='mr-1 md:mt-0.5'/> }
        <div className='flex flex-row flex-wrap md:flex-col'>
          {
            tags.map((item, idx) => {
              if ( !(item in blogTagColors) ) { console.error(`No color for tag '${item}' found in content/blogTagColors.json!`) };
              return <span key={idx} style={{borderColor: blogTagColors[item]}} className='rounded text-center border-2 pl-1 pr-1 mr-0.5 mb-0.5'>{item}</span>;
            })
          }
        </div>
      </div>
    </div>
  );

  return (
    <>{ !hidden ?
      <LinkRouter to={makeBlogPostURL(title)}>
        <div className='relative flex flex-col md:flex-row rounded-3xl shadow-xl border-black border p-5 mt-4 mb-1 bg-white dark:bg-dark-accent hover:scale-102'>
          {/* Date and Tags loc 1 */}
          <div className='absolute -left-40 hidden md:flex'>
            {dateAndTags}
          </div>
          <div className='md:w-6/12'>
            {/* Title */}
            <h1 className='text-xl mb-0.5'>{title}</h1>
            <div className='flex flex-wrap items-center text-xs'>
              {/* Authors */}
              { !isMobile ? authors.map((item, idx) => {
                return <span key={idx} className='text-dark-accent dark:text-light-accent2'>{item} {idx<authors.length-1 ? <>,&nbsp;</> : <></>}</span>;
              }) : null }
              {/* Date and Tags loc 2 */}
              { isMobile ? dateAndTags : null }
              {/* Main text */}
              <p className='mt-2 text-base'>{description}</p>
            </div>
          </div>
          {/* Cover Image */}
          <div className='m-auto'><img src={coverImage} className='max-h-40 rounded-lg'/></div>
        </div>
      </LinkRouter>
    : null}</>
  )
}



export default BlogPostSection